<template>
  <div class="support-store">
    <div class="page-wrapper pt-0 pb-0" style="position: relative">
      <h3 class="title hide show-sm bold" style="position: absolute; margin: 7% auto; width: 100%; text-align: center">
        SUPPORT THE STORES
      </h3>
      <p
        class="hide show-sm"
        style="font-size: 16px; text-align: center; position: absolute; top: 6%; margin: 10% 14% 0 14%; color: white"
      >
        Supporting local businesses is critical - now more than ever. As shopkeepers close their physical storefronts,
        they will rely heavily on online sales to keep their businesses thriving, or afloat. Here, we’ve curated a
        shoppable directory of the incredible retailers in our network, where you can shop by state. Whether it’s
        skincare steals, cozy loungewear, luxury candles or games and puzzles - they’ve got you covered. Consider
        swapping your Amazon fix for these online storefronts instead. Every dollar you spend with your community makes
        a difference. Let's band together and Support the Stores.
      </p>
      <img
        src="https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/2f255b72-641a-41b0-ae38-1b4fd31205a6"
        class="hide show-sm"
        style="height: 550px; width: 100%; object-fit: cover; object-align: top"
      />
      <p
        class="show hide-sm"
        style="font-size: 1.6vw; text-align: center; position: absolute; top: 12%; margin: 14% 11%; color: white"
      >
        Supporting local businesses is critical - now more than ever. As shopkeepers close their physical storefronts,
        they will rely heavily on online sales to keep their businesses thriving, or afloat. Here, we’ve curated a
        shoppable directory of the incredible retailers in our network, where you can shop by state. Whether it’s
        skincare steals, cozy loungewear, luxury candles or games and puzzles - they’ve got you covered. Consider
        swapping your Amazon fix for these online storefronts instead. Every dollar you spend with your community makes
        a difference. Let's band together and Support the Stores.
      </p>
      <img
        src="https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/a36bcd05-44c1-4e46-ad8e-eca173d3f275"
        style="width: 100%"
        class="show hide-sm"
      />
    </div>
    <div class="page-wrapper page-wrapper--white pb-30 pt-30-sm pb-30-sm">
      <div class="container">
        <headline :title="'shop our retailers'" class="mb-30-sm"></headline>
        <div class="grid-wrapper grid-wrapper--col__4">
          <retailer-tile v-for="(retailer, i) in retailerList" :key="'retailer_' + retailer.id + i" :data="retailer" />
        </div>
      </div>
    </div>
    <div class="page-wrapper page-wrapper--white pb-130 pt-30-sm pb-30-sm">
      <div class="container">
        <headline :title="'shop retailers by state'" class="mb-30-sm"></headline>
        <div v-for="(stateContainer, propertyName) in this.hash" class="" style="width: 55%; margin-left: 25%">
          <h3 class="title letter-spacing my-20 mt-40-sm mb-30-sm font-size-33-sm line-height-38-sm">
            {{ propertyName }}
          </h3>
          <div
            class="
              grid-wrapper
              font-size-16
              grid-wrapper--col__2
              cambon-regular-medium
              med
              mb-40 mb-50-sm
              text-left-sm text-left-sm
              font-size-16-sm
            "
          >
            <ul>
              <li v-for="store in stateContainer.col1">
                <a class="block underline hover" target="_blank" :href="store.URL">{{ store.Retailer }}</a>
              </li>
            </ul>
            <ul>
              <li v-for="store in stateContainer.col2">
                <a class="block underline hover" target="_blank" :href="store.URL">{{ store.Retailer }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="page-wrapper page-wrapper--white pb-30 pt-30-sm pb-30-sm">
      <div class="container">
        <headline :title="'shop more great retailers'" class="mb-30-sm"></headline>
        <div class="grid-wrapper grid-wrapper--col__4">
          <retailer-tile v-for="(retailer, i) in retailerList2" :key="'retailer_' + retailer.id + i" :data="retailer" />
        </div>
      </div>
    </div>
    <div class="pt-30-sm pb-30-sm">
      <div class="grid-12 purple-bg">
        <div class="container span-6 span-12-md mr-30 mx-0-md mr-0-above-md pr-30-above-md">
          <div class="px-0">
            <headline :title="'Donate to the Small Business Relief Fund'" class="mb-0 mt-40 mt-30-sm"></headline>
            <p class="font-size-28 mt-50 mb-60 mb-60-md pr-50">
              To respond to this crisis for at-risk businesses across the US, The Opportunity Fund is working with
              individuals, businesses, foundations, and the government to create a Small Business Relief Fund harnessing
              support to provide immediate relief to struggling self-employed and small business owners.
            </p>
            <a
              target="_blank"
              href="https://www.opportunityfund.org/donate/"
              class="inline-block button button-transparent mb-80 mb-50-sm width-100-md"
              >DONATE HERE</a
            >
          </div>
        </div>
        <img
          src="https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/861b1d6f-5b22-4a4b-8d7d-18dc7c958495"
          alt="image-about-3"
          class="width-100 height-100 min-height-60 min-height-290-sm object-fit-cover span-6 span-12-md"
        />
      </div>
    </div>
    <!-- apply now -->
    <div class="page-wrapper page-wrapper--grey pt-130 padding-bottom-130">
      <div class="container">
        <div class="text-center">
          <h1 class="title mb-50 font-size-70 font-size-20-sm">Join the Bulletin Board</h1>
          <p class="margin-bottom-40 cambon-regular-medium line-height-26">
            We’ve launched a dedicated forum for our wholesale community. Here, connect with the other brands and
            retailers in our network to pose and answer questions, swap tips and tricks, and share what's on your mind.
          </p>
          <div class="button-wrapper">
            <a
              href="https://bulletin.zendesk.com/hc/en-us/community/topics"
              class="button min-width-280 button-transparent"
            >
              Join now
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Hero from "../hero/hero.vue";
import About from "../about/about.vue";
import RetailerTile from "./retailer-tile.vue";
import RetailerData from "../../../data/_retailers.json";
export default {
  components: {
    Hero,
    About,
    RetailerTile,
  },
  data() {
    return {
      retailerList: o,
      retailerList2: o2,
      hash: {},
    };
  },
  mounted() {
    const h = {};
    RetailerData.map((item) => {
      if (!h.hasOwnProperty(item.State)) {
        h[item.State] = [];
      }
      h[item.State].push({ Retailer: item.Retailer, URL: item.URL });
    });
    for (var state in h) {
      h[state] = h[state].sort(function (a, b) {
        var nameA = a.Retailer.toUpperCase(); // ignore upper and lowercase
        var nameB = b.Retailer.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        // names must be equal
        return 0;
      });
      var left = h[state].splice(0, Math.ceil(h[state].length / 2));
      h[state] = {
        col1: left,
        col2: h[state],
      };
    }
    this.hash = h;
  },
};

const o = [
  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/1fad5e34-5f97-470a-8e5c-37a801deedb7",
    retailer_name: "Darling Distraction",
    link: "https://www.darlingdistraction.com/",
    location: "Portland, Oregon",
  },

  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/3af32def-4c29-4b20-a124-f0ac65933b7c",
    retailer_name: "Onatah",
    link: "https://shoponatah.com/",
    location: "Indianapolis, Indiana",
  },

  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/cf4258b7-7538-4672-b896-2bed760ec5c9",
    retailer_name: "Prism",
    link: "https://prismseattle.com/",
    location: "Seattle, Washington",
  },

  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/fe72efad-0332-4dc5-807d-5fc26438c84a",
    retailer_name: "The Chute",
    link: "https://thechuteonline.com/",
    location: "Omaha, Nebraska",
  },

  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/436f2e25-8a73-44e3-89fb-1027091c1522",
    retailer_name: "The Stockist",
    link: "https://www.thestockistshop.com/",
    location: "Salt Lake City, Utah",
  },
  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/3894a0f5-b911-4265-8d08-18a868dbb0e5",
    retailer_name: "Tumble",
    link: "https://www.wearetumble.com/",
    location: "Albuquerque, New Mexico",
  },
  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/a3272991-97c6-44ab-948a-029ef1049d2b",
    retailer_name: "Apt. F",
    link: "https://www.shopaptf.com/",
    location: "Austin, Texas",
  },
  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/91b9f78e-5929-4e4c-a9eb-ba060800000f",
    retailer_name: "Individual Medley Store	",
    link: "https://individualmedleystore.com/",
    location: "Los Angeles, California",
  },
  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/f0c7f41b-3a06-49d7-8c00-847884f8bcdb",
    retailer_name: "FEELS",
    link: "https://feelsnyc.com/",
    location: "New York, New York",
  },
  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/04354fcf-61c7-4cb2-ac4c-450a947119d4",
    retailer_name: "Garden Party",
    link: "https://www.shopgardenparty.com/",
    location: "Asheville, North Carolina",
  },
  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/b9e90718-9931-449a-8d31-7c9f3800893c",
    retailer_name: "Hygge",
    link: "https://shophyggesavannah.com/",
    location: "Savannah, Georgia",
  },
  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/34d26c8e-0ad3-4484-ba2a-b88b7837f891",
    retailer_name: "Local Nomad",
    link: "https://www.localnomadshop.com/",
    location: "Phoenix, Arizona",
  },
];
const o2 = [
  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/e0648dd9-e19b-4216-a78d-4e537aed7563",
    retailer_name: "Parc",
    link: "https://parcboutique.com/",
    location: "Denver, Colorado",
  },
  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/f8342285-be65-4bf8-87fd-4387f61e905a",
    retailer_name: "Olives & Grace",
    link: "https://www.olivesandgrace.com/",
    location: "Boston, Massachusetts",
  },
  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/5742b57a-c6f1-47ca-9077-f51d529ad9d4",
    retailer_name: "Solare",
    link: "https://solare-shop.com/",
    location: "Oklahoma City, OK",
  },
  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/703edfcc-0129-4ccd-99bc-79cb0da4bcaa",
    retailer_name: "URSA",
    link: "https://www.shopursa.com/",
    location: "Milwaukee, Wisconsin",
  },
  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/006e1298-148c-463f-b85e-b65afd6bc0f9",
    retailer_name: "Meek",
    link: "https://shopmeek.co/",
    location: "Denver, Colorado",
  },
  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/87574f0a-8515-44ab-8795-19f991f9efd9",
    retailer_name: "Tortuga",
    link: "http://gettortuga.com/",
    location: "	Baltimore, Maryland",
  },
  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/7c4533a3-9110-423e-9d35-d3df7249f521",
    retailer_name: "Handzy",
    link: "https://handzyshopstudio.com/",
    location: "Covington, Kentucky",
  },
  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/71bdc921-2fa1-48ed-93fc-b06747d9c93b",
    retailer_name: "Dear Neighbor",
    link: "https://shopdearneighbor.com/",
    location: "Richmond	Virginia",
  },
  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/338f48db-2fa2-4fcd-8adb-0f8669d8e322",
    retailer_name: "The General Public",
    link: "http://www.the-generalpublic.com/",
    location: "Missoula, Montana",
  },
  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/f24e94d0-386b-4a8e-9b5a-3050fce799a5",
    retailer_name: "Juju",
    link: "http://www.jujumaine.com/",
    location: "Portland, Maine",
  },
  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/192239ef-34eb-415e-88be-f72bc5d7660a",
    retailer_name: "Ritual Shoppe",
    link: "https://ritualshoppe.com/",
    location: "	Philadelphia, Pennsylvania",
  },
  {
    thumbnail_image_url:
      "https://s3.us-east-1.amazonaws.com/productions3.bulletin.co/296c2d64-cfba-4bc7-8dbb-0b6b60aaa883",
    retailer_name: "The Safari Collective",
    link: "https://thesafaricollective.com/",
    location: "New Milford, Connecticut",
  },
];
</script>
